import {collection,doc,getDoc,runTransaction,serverTimestamp} from "firebase/firestore";
import {getStorage,ref,getBlob,getMetadata,uploadBytes} from "firebase/storage";
import {db} from "../firebaseConfig";
import {rosterFileType,ROSTER_FILE_LIMIT} from "./rosterFileModel";

export async function saveRosterFile(jobId,file,uid) {
  const {extension,contentType}=rosterFileType(file),buffer=await file.arrayBuffer();
  const digest=await window.crypto.subtle.digest("SHA-256",buffer),id=Array.from(new Uint8Array(digest),byte=>byte.toString(16).padStart(2,"0")).join("");
  const reference=doc(collection(db,"banner_jobs",jobId,"roster_files"),id),existing=await getDoc(reference);
  if(existing.exists())return {id,...existing.data(),alreadySaved:true};
  const storagePath=`banner_roster_files/${jobId}/${id}/original`,object=ref(getStorage(),storagePath);
  let metadata;
  try{metadata=await getMetadata(object);}catch(error){if(error.code!=="storage/object-not-found")throw error;}
  if(!metadata){
    try{await uploadBytes(object,buffer,{contentType,customMetadata:{sha256:id}});}
    catch(error){
      // A prior attempt or concurrent upload may already have saved this exact original.
      metadata=await getMetadata(object).catch(()=>{throw error;});
    }
  }
  if(metadata && (metadata.customMetadata?.sha256!==id || metadata.size!==file.size || metadata.contentType!==contentType))throw new Error("The saved original does not match this file. Contact a banner manager.");
  const data={name:file.name.slice(0,240),extension,contentType,size:file.size,storagePath,sha256:id,createdBy:uid,createdAt:serverTimestamp()};
  try{
    await runTransaction(db,async transaction=>{const current=await transaction.get(reference);if(!current.exists())transaction.set(reference,data);});
  }catch(error){throw new Error("The original uploaded, but its job record could not be saved. Select the same file and retry; it will reuse the saved original. "+(error.code || ""));}
  return {id,...data};
}
export async function rosterOriginalBlob(file) {
  const storage=getStorage();storage.maxOperationRetryTime=12000;
  let timer;
  try{
    // Avoid Range requests: the app's existing Storage CORS policy permits ordinary GETs.
    const blob=await Promise.race([getBlob(ref(storage,file.storagePath)),new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error("Roster download timed out. Retry to load the saved original.")),20000);})]);
    if(blob.size>ROSTER_FILE_LIMIT)throw new Error("This roster exceeds the 10 MB limit.");
    return new Blob([blob],{type:file.contentType});
  }finally{clearTimeout(timer);}
}
